module.exports = __webpack_public_path__ + "img/pass.b97bc9da.png";